"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobilePush = void 0;
/** an enumeration of supported mobile push services */
var MobilePush;
(function (MobilePush) {
    /** Google Firebase Cloud Messaging (FCM) */
    MobilePush["FCM"] = "GCM";
    /** Apple Push Notification Service (APNS) */
    MobilePush["APNS"] = "APNS";
    /** Apple Push Notification Service - Development (APNS_SANDBOX) */
    MobilePush["APNS_SANDBOX"] = "APNS_SANDBOX";
})(MobilePush || (exports.MobilePush = MobilePush = {}));
